export default {
  type: 'Tipo',
  relevanceNo: 'Número de orden asociado',
  consultContent: 'Contenido de la consulta',
  submitTime: 'Hora de envío',
  consultTypeEnum: {
    0: 'Consulta de pedido',
    1: 'Consulta de paquete',
  },
  consultStatusEnum: {
    0: 'sin tratar',
    1: 'en proceso',
    2: 'completado',
  },
}
